import React, { ChangeEvent, FC, memo } from 'react';
import { Input } from 'antd';
import classNames from 'classnames';
import { Popup } from 'shared/ui/Popup';
import { ReactComponent as InfoIcon } from 'shared/assets/icons/InfoIcon.svg';

const { TextArea: AntdTextArea } = Input;

interface TextAreaProps {
  value?: Nullable<string>;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  bordered?: boolean;
  rows?: number;
  isDisabled?: boolean;
  requiredMark?: boolean;
  tooltip?: string;
  label?: string;
  containerClassName?: string;
  onTouchStart?: (value: CustomAny) => void;
  readOnly?: boolean;
  defaultValue?: Nullable<string>;
}

export const TextArea: FC<TextAreaProps> = memo((props) => {
  const {
    value,
    placeholder,
    className,
    onChange,
    rows,
    isDisabled,
    bordered = false,
    requiredMark,
    tooltip,
    label,
    containerClassName,
    onTouchStart,
    readOnly,
    defaultValue,
  } = props;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    onChange?.(e.target.value);
  };
  const handleTouch = (): void => {
    onTouchStart?.(value || []);
  };

  return (
    <div className={classNames('flex flex-col', containerClassName)}>
      <div className="flex">
        {label && <div className="mb-2.5 mr-2">{label}</div>}
        {tooltip && (
          <Popup title={label} description={tooltip}>
            <InfoIcon width={22} height={22} className="[&>path]:stroke-primaryLight" />
          </Popup>
        )}
      </div>
      {requiredMark && <div className="text-error text-2xl absolute z-10 top-0 left-1 pointer-events-none">*</div>}
      <AntdTextArea
        className={classNames('bg-accentLight text-lg placeholder:text-lg placeholder:font-medium', className)}
        variant={bordered ? 'outlined' : 'borderless'}
        size="large"
        rows={rows}
        placeholder={placeholder}
        value={value || undefined}
        onChange={handleChange}
        disabled={isDisabled}
        onClick={handleTouch}
        readOnly={readOnly}
        defaultValue={defaultValue || undefined}
      />
    </div>
  );
});
